import { Component, Input } from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: [],
})
export class AppNavItemComponent {
  @Input() item: any;
  @Input() depth: any;
  hoveredItem: any = null; 

  constructor(public navService: NavService, public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }
  @Input() collapsed = false;

  selectedRoute: string = '';

  onItemSelected(item: NavItem) {
    if (!item.children?.length) {
      this.selectedRoute = item.route ?? ''; 
      this.router.navigate([item.route]);
      this.navService.closeSidenav();
    }
  


    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0,
    });
  }
  mainSections = {
    investors: [
      '/investors',
      '/InvestorProfile',
      '/InvestorDetails',
      '/JointHolderDetails',
      '/NomineeDetials',
      '/UploadDocuments',
      '/BankDetials',
      '/IMList'
    ],
    settings: ['/settings'],
    dashboard: ['/dashboard'],
    admin: ['/Adminops'],
  };
   parentRoutes: { [key: string]: string[] } = {
    '/Investor/investors': [
      '/Investor/InvestorDetails',
      '/Investor/AddNewInvestor',
      '/Investor/Contributionsaturemanagement',
      '/Investor/ContributionAgreement',
      '/Investor/FatcaSignatureManagement',
      '/Investor/Fatca',
      '/Investor/PpmSignatureManagements',
      '/Investor/Ppm',
      '/Investor/commitment',
      '/Investor/UploadDocuments',
      '/Investor/BankDetails',
      '/Investor/NomineeDetails',
      '/Investor/JointHolderDetails',
      '/Investor/InvestorProfile',
      '/Investor/Folio',
      '/Investor/ProfileInvestments',
      '/Investor/ProfileDashboard',
      '/Investor/KycVerification',
      '/Investor/reviewverify',
      '/Investor/jointholder-esign',
      '/Investor/jointholder-verfication',
      '/Investor/jointholder-info'

    ],
    '/Schemes/badge': [
      '/Schemes/ViewScheme',
      '/Schemes/SchemeInvestments',
      '/Schemes/SchemeInvestors',
      '/Schemes/SchemeDashboard',
      '/Schemes/AddNewSchemes',
      '/Schemes/AddInvestorScheme',
       '/Schemes/CommitmentMIS',
       '/Schemes/Closing',
       '/Schemes/ClosingPrice',
       '/Schemes/Drawdown',
       '/Schemes/ViewDrawdown',
       '/Schemes/AddInvestorsClass',
       '/Schemes/Ledger',
        '/Schemes/Nav',
        '/Schemes/AllocatedUnits',
         '/Schemes/distribution',
         '/Schemes/ManagementFee'
    ],
    '/Capital-calls/capitalcalls': [
       '/Capital-calls/AddDrawdown',
       '/Capital-calls/CheckReceivable',
       '/Capital-calls/GenerateDrawdown',
       '/Capital-calls/GenerateNotices',
       '/Capital-calls/AddReceivables'
    ],
    '/Doc-management/Documentvault': [
      '/Doc-management/BulkUploadadd',
      '/Doc-management/Standarddocument',
      '/Doc-management/ViewCoordinates',
      '/Doc-management/AddCoordinates',
      '/Doc-management/AddSignatories',
      '/Doc-management/AddTemplate',
      '/Doc-management/BulkUploadview',
      '/Doc-management/doc-details',
      '/Doc-management/docs-list',
      '/Doc-management/doc-details',
       '/Doc-management/Viewtemplate',
       '/Doc-management/Generatedoc',
       '/Doc-management/userprofile',
       '/Doc-management/managevariables',
        '/Doc-management/InApp',
        '/Doc-management/TemplateMapping',
         '/Doc-management/Whatsapp'
    ],
    '/Portfolio-investments/PortfolioInvestments': [
      '/Portfolio-investments/investment-overview',
      '/Portfolio-investments/investment-history'
    ],
    '/Admin-ops/improfile': [
      '/Admin-ops/AddInvestorClass',
      '/Admin-ops/InvestorClass',
      '/Admin-ops/SMTPSetup',
      '/Admin-ops/managecodemaster',
      '/Admin-ops/Configguration',
      '/Admin-ops/thirdpartyappsetting',
      '/Admin-ops/UserManagement',
      '/Admin-ops/UsersWorkspace',
      '/Admin-ops/LoginHistory',
      '/Admin-ops/notification2',
      '/Admin-ops/RoleBasedAccess',
       '/Admin-ops/Events',
        '/Admin-ops/AuditLog',
        '/Admin-ops/EmailLog',
        '/Admin-ops/StorageConfiguration',
        '/Admin-ops/BrandingLogo',
        '/Admin-ops/AllocationPriority',
        '/Admin-ops/RoleWorkspace',
        '/Admin-ops/Adminops',
        '/Admin-ops/LoginSetting',
        '/Admin-ops/RoleWorkspace',
        '/Admin-ops/NotificationChannel',
        '/Admin-ops/SubscriptionManagement',
    ],
    '/Super-admin/IMList':[
      '/Super-admin/IMSetup',
      '/Super-admin/Subscription',
      '/Super-admin/DatabaseCreation',
      '/Super-admin/DatabaseRestore',
      '/Super-admin/IMInformation',
      '/Super-admin/LookupInitialization',
      '/Super-admin/Configguration',
      '/Super-admin/ProvisioningLogs'

    ],
        '/Super-admin/ai-dashboard': [
      '/Super-admin/ai-models',
      '/Super-admin/ai-operation-master',
      '/Super-admin/ai-templates',
      '/Super-admin/ai-prompt-playground',
      '/Super-admin/ai-vendors',
      '/Super-admin/ai-operation',
      '/Super-admin/ai-usage',
      '/Super-admin/ai-auditlog'
      
    ],
    '/Super-admin/Modules': [
      '/Super-admin/Features',
      '/Super-admin/Actions',
      '/Super-admin/FeatureActions',
      '/Super-admin/FeatureWorkspace',
       '/Super-admin/SystemRoles',
       '/Super-admin/SystemRoleWorkspace'
      
    ],
    '/Super-admin/Products': [
      '/Super-admin/Editions',
      '/Super-admin/EntitlementWorkspace',
      '/Super-admin/Entitlements'
      
    ],
     '/Super-admin/AuditLog': [
      '/Super-admin/VariableMaster',
       '/Super-admin/CodeMaster',
        '/Super-admin/CodeMasterGroups',
        '/Super-admin/WorkflowStage',
        '/Super-admin/WorkflowType',
        '/Super-admin/NotificationEvent',
        '/Super-admin/TemplateMaster',
        '/Super-admin/EventTemplateMapping'
      
    ],
    '/Customer/Funds': [
      '/Customer/Capitalcalls',
      '/Customer/ViewFund',
      '/Customer/FatcaSignatureManagement',
      '/Customer/Fatca',
      '/Customer/SignatureManagement',
      '/Customer/PpmDocuments',
      '/Customer/commitment',
      '/Customer/UploadDocuments',
      '/Customer/BankDetails',
      '/Customer/NomineeDetails',
      '/Customer/JointHolderDetails',
      '/Customer/InvestorProfile',
      '/Customer/Folio',
      '/Customer/InvestorProfile',
      '/Customer/paymentview',
      '/Customer/Distributionview',
      '/Customer/custdistribution',

    ],
     '/Customer/Transaction':[
      '/Customer/LedgerView',
    ],
    '/Distribution/DistributionMain': [
      '/Distribution/DistAllocate',
      '/Distribution/DistDispatch',
      '/Distribution/DistPayments',
    ],
        '/Investor/AddNewInvestor': [
      '/Investor/InvestorDetails',
      '/Investor/KycVerification',
      '/Investor/Contributionsaturemanagement',
      '/Investor/ContributionAgreement',
      '/Investor/FatcaSignatureManagement',
      '/Investor/Fatca',
      '/Investor/PpmSignatureManagements',
      '/Investor/Ppm',
      '/Investor/commitment',
      '/Investor/UploadDocuments',
      '/Investor/BankDetails',
      '/Investor/NomineeDetails',
      '/Investor/JointHolderDetails',
      '/Investor/InvestorProfile',
      '/Investor/Folio',
      '/Investor/ProfileInvestments',
      '/Investor/ProfileDashboard',
      '/Investor/KycVerification',
      '/Investor/reviewverify',
      '/Investor/jointholder-esign',
      '/Investor/jointholder-verfication',
      '/Investor/jointholder-info'

    ],

  };

  isMenuActive(route: string): boolean {
    const currentUrl = this.router.url;

 
    if (currentUrl.startsWith(route)) {
      return true;
    }


    return this.parentRoutes[route]?.some(subRoute => currentUrl.startsWith(subRoute)) || false;
  }
  
}
